import styled from 'styled-components';

export const Label = styled.label`
  line-height: ${({ lineheight }) => (lineheight ? lineheight : '17px')};
  font-size: ${({ size }) => (size ? size : '14px')};
  font-family: ${({ altFont }) => (altFont ? 'Roboto' : 'Noto Sans')};
  font-weight: ${({ weight }) => (weight ? weight : 'bold')};
  color: ${({ theme, color }) => (color ? color : theme.black)};
  margin-bottom: ${({ mb }) => (mb ? mb : '8px')};
  margin-top: ${({ mt }) => (mt ? mt : '0')};
  margin-right: ${({ mr }) => (mr ? mr : '0')};
  margin-left: ${({ ml }) => (ml ? ml : '0')};
  float: ${({ float }) => float ? float : 'none'};
  cursor: ${({ showPointer }) => (showPointer ? 'pointer' : 'default')};
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'left')};
  ${({ textOverflow, width }) => textOverflow ? `
    width: ${width ? width : '100%'};
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
  ` : ''}
`